export default __webpack_public_path__ + "static/media/youtube.384e3dc4.svg";